import padding from './padding.styles.esm.js';

var cardCommon = {
  padding: padding
};

export { cardCommon as default };
//# sourceMappingURL=index.esm.js.map
